import { cn } from "@omni/utils/styles";

import { useDropdownContext } from "@/components/General/Dropdown/context/dropdown.context";

type CaretProps = {
    className?: string;
};

export const Caret = ({ className }: CaretProps) => {
    const { isOpen } = useDropdownContext();

    return (
        <svg
            className={cn(
                "tw:w-4 tw:inline-block",
                {
                    "tw:rotate-z-180": isOpen
                },
                className
            )}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className={cn("tw:fill-current")}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.00003 8.5C6.59557 8.5 6.23093 8.74364 6.07615 9.11732C5.92137 9.49099 6.00692 9.92111 6.29292 10.2071L11.2929 15.2071C11.6834 15.5976 12.3166 15.5976 12.7071 15.2071L17.7071 10.2071C17.9931 9.92111 18.0787 9.49099 17.9239 9.11732C17.7691 8.74364 17.4045 8.5 17 8.5H7.00003Z"
            />
        </svg>
    );
};
